import moment from 'moment';
import * as yup from 'yup';

const isTextEditorValid = (content: string) => {
  const strippedContent = content.replace(/<(.|\n)*?>/g, '').trim();
  return strippedContent.length > 0;
};

export const formSchemaFn = (isActionEdit: boolean) =>
  yup.object().shape({
    formName: yup.string().optional(),
    attachment: yup
      .string()
      .test(
        'check-images',
        'カバー画像をアップロードしてください。',
        (_, context) => {
          const image = context?.parent?.coverImage || '';
          return image !== null && image !== '';
        },
      ),
    title: yup
      .string()
      .trim()
      .required('タイトルは未入力です。')
      .max(40, 'タイトルは40文字以内で入力してください。'),
    description: yup
      .string()
      .trim()
      .required('説明は未入力です。')
      .max(2000, '説明は2000文字以内で入力してください。'),
    partnerId: yup.number().required('提供元を選択してください。'),
    tagNames: yup
      .array()
      .of(yup.string().required())
      .required('タグを選択してください。')
      .min(1, 'タグを選択してください。'),
    useCoupon: yup
      .number()
      .oneOf([0, 1])
      .required('クーポン利用有無を選択してください。'),
    couponCode: yup
      .string()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .when('useCoupon', ([useCoupon], schema) => {
        if (Number(useCoupon) === 1)
          return schema
            .required('クーポンコードは未入力です。')
            .max(15, 'クーポンコードは15文字以内で入力してください。');
        return schema.optional();
      }),
    couponExpiredAt: yup
      .date()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .when('useCoupon', ([useCoupon], schema) => {
        if (Number(useCoupon) === 1)
          return schema
            .required('クーポン有効期限を選択してください。')
            .min(
              moment().add(1, 'minute').startOf('minute').toDate(),
              isActionEdit
                ? 'クーポン有効期限が過去のため、更新できません。'
                : 'クーポン有効期限は現在以降を選択してください。',
            );
        return schema.optional();
      }),
    details: yup
      .string()
      .nullable()
      .optional()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .test('url-or-empty', 'URLは正しい形式で入力してください。', (value) => {
        if (
          value === null ||
          value === undefined ||
          String(value).trim() === ''
        ) {
          return true;
        }
        try {
          new URL(String(value));
          return true;
        } catch {
          return false;
        }
      })
      .max(2000, '遷移先は2000文字以内で入力してください。'),
    ctaText: yup
      .string()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .required('CTA文言は未入力です。')
      .max(30, 'CTA文言は30文字以内で入力してください。'),
    linkUrl: yup
      .string()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .url('URLは正しい形式で入力してください。')
      .required('URLが入力されていません。')
      .max(2000, '遷移先は2000文字以内で入力してください。'),
    publicAt: yup
      .date()
      .required('公開日時を選択してください。')
      .when(['status'], ([status], schema) => {
        if (status !== 1 || isActionEdit) return schema;
        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          '公開日時は現在以降を選択してください。',
        );
      }),
    publicEndAt: yup
      .date()
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr))
      .when('publicAt', ([publicAt], schema) => {
        if (!publicAt) return schema;
        return schema.min(
          moment(publicAt).startOf('minute').toDate(),
          '公開終了日時は公開日時より後にしてください。',
        );
      }),
    status: yup
      .number()
      .required('ステータスは未入力です。')
      .oneOf([0, 1], 'ステータスは未入力です。'),
  } as any);
